import { GithubOutlined } from '@ant-design/icons';
import { DefaultFooter } from '@ant-design/pro-components';
import React from 'react';

const Footer: React.FC = () => {
  return (
    <DefaultFooter
      style={{
        background: 'none',
      }}
      copyright="All rights reserved"
      links={[
        {
          key: 'SEQUILERN',
          title: 'SEQUILERN',
          href: 'https://sequilern.com',
          blankTarget: true,
        },
      ]}
    />
  );
};

export default Footer;
